
import {
  IconChevronRight,
  RevList,
  RevListItem,
  openModal,
} from '@backmarket/design-system'
import { mapGetters } from 'vuex'

import { MODAL_NAMES } from '@config/constants'

import FaqModal from '../Modals/FaqModal'
import PerksModal from '../Modals/PerksModal'
import TechSpecModal from '../Modals/TechSpecModal'
import { CATEGORIES_WITH_HIGHLIGHTED_TECH_SPECS } from '../TechnicalSpecifications/TechnicalSpecifications.constants'

import translations from './AdditionalInfo.translations'

export default {
  components: {
    RevList,
    RevListItem,
    IconChevronRight,
    PerksModal,
    FaqModal,
    TechSpecModal,
  },
  props: {
    categoryId: {
      type: Number,
      required: true,
    },
    listingId: {
      type: Number,
      required: true,
    },
    technicalSpecifications: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      experiments: 'experiments/getExperiments',
    }),

    translations: () => translations,

    shouldShowTechnicalSpecifications() {
      return (
        this.experiments.ppTechSpecsVisibility !== 'ppTechSpecsHighlighted' ||
        !CATEGORIES_WITH_HIGHLIGHTED_TECH_SPECS.includes(this.categoryId)
      )
    },
  },
  methods: {
    deployTechSpecModal() {
      openModal(MODAL_NAMES.PRODUCT.TECH_SPECS)
    },

    deployFaqModal() {
      openModal(MODAL_NAMES.PRODUCT.FAQ)
    },

    deployPerksModal() {
      openModal(MODAL_NAMES.PRODUCT.PERKS)
    },
  },
}
